import { FsCore } from '@t/fs-core'

const mortgageCalculatorTypes = {
  mortgageAmount: 'int',
  propertyValue: 'int',
  additionalBorrowing: 'int',
  repaymentPeriod: 'int',
  rateType: 'string',
  paymentType: 'string',
  initialPeriod: 'string',
  deposit: 'int',
  annualIncome1: 'int',
  annualIncome2: 'int',
  debt1: 'int',
  debt2: 'int',
  otherSourcesOfIncome1: 'int',
  otherSourcesOfIncome2: 'int',
  applicantCount: 'int',
  mortgageType: 'string',
  linkType: 'string',
  timeframeForMortgage: 'int',
  timeframeForMortgageNatWest: 'int',
  currentProvider: 'string',
  borrowMoreAmount: 'int',
  financialDifficulty: 'string',
  borrowMore: 'string',
  location: 'string',
}

const parseCalculatorInputs = (input: string, str: string) => {
  if (mortgageCalculatorTypes[input] === 'int') {
    const removeNonAlphaNumeric = str.replace(/\W/g, '')
    const stringParsedToInteger = parseInt(removeNonAlphaNumeric, 10)

    if (!isNaN(stringParsedToInteger)) {
      return stringParsedToInteger
    }
    return removeNonAlphaNumeric
  }

  if (mortgageCalculatorTypes[input] === 'string') {
    return str
  }

  return str
}

const cleansedUserInputs = (userInputs: FsCore.CalculatorInputs): FsCore.CalculatorInputs =>
  Object.keys(userInputs).reduce(
    (acc, key) => ({
      ...acc,
      [key]:
        typeof userInputs[key] === 'string'
          ? parseCalculatorInputs(key, userInputs[key])
          : userInputs[key],
    }),
    {},
  )

export default cleansedUserInputs
